const filteredBugsnagErrorMessages = [
  'globalThis',
  'ResizeObserver'
];

export default filteredBugsnagErrorMessages;
